/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyMembersOverviewTotalsResponse } from '../../models/company-members-overview-totals-response';

export interface GetCompanyMembersOverviewTotals$Params {
}

export function getCompanyMembersOverviewTotals(http: HttpClient, rootUrl: string, params?: GetCompanyMembersOverviewTotals$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyMembersOverviewTotalsResponse>> {
  const rb = new RequestBuilder(rootUrl, getCompanyMembersOverviewTotals.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyMembersOverviewTotalsResponse>;
    })
  );
}

getCompanyMembersOverviewTotals.PATH = '/api/company/members/overview-totals';
